import { injectable } from 'tsyringe'
import {
  ForgotPasswordVerifyRequestInterface,
  LoginRequestInterface,
  ResetPasswordRequestInterface,
} from '@/data/payload/contracts/AuthRequest'
import { Account, OTP, ProfileMfaOtpResponse, Token } from '@/domain/entities/Account'
import { ExchangeOTPRequest, ForgotPasswordRequest, LoginApiRequest, ProfileMfaOtpRequest, RequestLibertaOTP } from '@/data/payload/api/AuthRequest'
import { AuthApiRepository } from '@/app/infrastructures/repositories/api/AuthApiRepository'

@injectable()
export class AuthPresenter {
  private repository: AuthApiRepository

  constructor(repository: AuthApiRepository) {
    this.repository = repository
  }

  public getMe(): Promise<Account> {
    return this.repository.getMe()
  }

  public onLogin(payload: LoginRequestInterface): Promise<Token> {
    return this.repository.login(payload)
  }

  public onLogin2FA(payload: LoginApiRequest) {
    return this.repository.login2fa(payload);
  }

  public forgotPassword(
    payload: ForgotPasswordRequest
  ): Promise<boolean> {
    return this.repository.forgotPassword(payload)
  }

  public forgotPasswordVerify(
    payload: ForgotPasswordVerifyRequestInterface
  ): Promise<boolean> {
    return this.repository.forgotPasswordVerify(payload)
  }

  public resetPassword(
    payload: ResetPasswordRequestInterface
  ): Promise<boolean> {
    return this.repository.resetPassword(payload)
  }

  public requestLibertaOTP(
    payload: RequestLibertaOTP
  ): Promise<OTP> {
    return this.repository.requestLibertaOTP(payload);
  }

  public exchangeOTP(
    payload: ExchangeOTPRequest
  ): Promise<string> {
    return this.repository.exchangeOTP(payload);
  }

  public request2FAOTP(
    payload: RequestLibertaOTP
  ) {
    return this.repository.request2FAOTP(payload)
  }

  public verify2FAOTP(
    payload: ExchangeOTPRequest
  ) {
    return this.repository.verify2FAOTP(payload)
  }
    
  public requestProfileMfaOtp(payload: ProfileMfaOtpRequest): Promise<ProfileMfaOtpResponse> {
    return this.repository.requestProfileMfaOtp(payload)
  }

  public verifyProfileMfaOtp(
    payload: ExchangeOTPRequest
  ): Promise<boolean> {
    return this.repository.verifyProfileMfaOtp(payload)
  }
}
